import React from 'react'
import { cm } from '../../utils'

export type TagVariant = 'success' | 'error' | 'warning' | 'info' | 'link'

export interface TagProps extends React.HTMLAttributes<HTMLDivElement> {
  variant?: TagVariant
  children: React.ReactNode
  bordered?: boolean
}

const variantClasses: Record<TagVariant, string> = {
  success: 'bg-tokens-status-success-3 text-tokens-status-success-2 border-tokens-status-success-2',
  error: 'bg-tokens-status-error-10 text-tokens-status-error-1 border-tokens-status-error-30',
  warning:
    'bg-tokens-status-warning-3 text-tokens-status-warning-1 border-tokens-status-warning-30',
  info: 'bg-[#F7F7FF] text-[#5B5BD5] border-tokens-primary-4',
  link: 'bg-tokens-status-link-base-2 text-tokens-status-link-3 border-[#5B5BD533]'
}

export const Tag = React.forwardRef<HTMLDivElement, TagProps>(
  ({ variant = 'info', children, className, bordered = true, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cm(
          'inline-flex justify-center items-center gap-1 px-[8px] py-[4px] rounded-full font-bold text-[10px] leading-[1] font-[Geist,sans-serif] select-none',
          variantClasses[variant],
          bordered ? 'border' : 'border-none',
          className
        )}
        {...props}
      >
        <span>{children}</span>
      </div>
    )
  }
)

Tag.displayName = 'Tag'

export default Tag
